import React from "react";
import Layout from "../../layouts/Layout";
import BButton from "../../components/general/BButton";
import { useNavigate } from "react-router-dom";
import actions from "../../redux/actions";
import { connect } from "react-redux";
import apiService from '../../utils/api.service';
import helper from "../../utils/helper";
import Notification from "../../services/notification.service";
import _ from "lodash"
class PointEvidence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      isSubmit: false,
      error: {},
      fileUploadError: false,
      fileUpload: null,
      filename: "",
      refreshFile: false,
      imageErr: false,
    };
    this.uploadFile = this.uploadFile.bind(this);
    this.uploadClear = this.uploadClear.bind(this);
    this.onRenewSave = this.onRenewSave.bind(this);
    this.getBase64 = this.getBase64.bind(this);
  }

  uploadClear() {
    this.setState({ fileUpload: null, filename: "", refreshFile: true });
    setTimeout(() => this.setState({ refreshFile: false }), 50);
  }
  uploadImage(notImage = false) {
    if (notImage) {
      document.getElementById("uploadImage").click();
    }
  }
  uploadFile(e){
    console.log(e.target.files[0]);
    let file = e.target.files[0]
    console.log('file >>', file)
    const MAXSIZEFILE = helper.CONFIG.MAXSIZEFILE
    const IMGTYPEFILE = helper.CONFIG.IMGTYPEFILE
    console.log("MAXSIZEFILE", MAXSIZEFILE);
    if (IMGTYPEFILE.includes(file.type) && file.size <= MAXSIZEFILE) {
      this.getBase64(file)
    } else {
      this.setState({ imageErr: true });
    }
  }
  getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const fileUpload = reader.result;
      this.setState({ imageErr: false, fileUpload: fileUpload, filename: file.name });
    };
    reader.onerror = (error) => {
      console.log("Error: ", error);
    };
  }
  onRenewSave() {
    console.log("props: ", this.props);
    const { fileUpload } = this.state;
    const payload = { memberId: this.props?.user?.lineId?.memberId ,picture: fileUpload };
    if (fileUpload) {
      this.onCreateGoenka(payload)
    }
  }

  async onCreateGoenka (payload) {
    try {
      console.log('payload >>', payload)
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Collect.CreateGoenka(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        Notification.success({ 
          title: "Success!", description: "บันทึกสำเร็จ" , 
          onCancel: () => { this.props.navigate(`/collect-point`) } 
        });
      }
      else {
        Notification.error({ title: "ขออภัย", description: "มีบางอย่างผิดพลาด" });
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }

  render() {
    const { data, error, refreshFile, imageErr } = this.state;
    const { isSubmit } = this.state;
    const { fileUpload } = this.state;
    return (
      <Layout>
        <div className="container-renew2">
          <section className="renew-form">
            <form>
              <div className="box-form">
                <div className="input-form">
                  <div className="upload-slip">
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "20px",
                        color: "#2685CA",
                        marginBottom: "10px",
                      }}
                    >
                      ปฏิบัติธรรมท่านโกเอ็นก้า
                    </div>
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#A8CEEA",
                        marginBottom: "20px",
                      }}
                    >
                      เลขที่สมาชิก : {this.props?.user?.lineId?.memberCode}
                    </div>
                    <label>
                      รูปภาพหลักฐานการปฏิบัติธรรมท่านโกเอ็นก้า
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    {refreshFile === false ? (
                      <input
                        id="uploadImage"
                        accept="image/*"
                        type="file"
                        onChange={this.uploadFile}
                      />
                    ) : (
                      <></>
                    )}
                    <div className="upload-container">
                      {fileUpload === null ? (
                        <>
                          <div
                            className={`input-upload ${ imageErr || isSubmit && !!fileUpload === false? 'err' : ''}`}
                            onClick={this.uploadImage}
                          >
                            <div className="icon">
                              <svg
                                width="44"
                                height="44"
                                viewBox="0 0 44 44"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M40.8571 17.2857H26.7143V3.14286C26.7143 1.40741 25.3069 0 23.5714 0H20.4286C18.6931 0 17.2857 1.40741 17.2857 3.14286V17.2857H3.14286C1.40741 17.2857 0 18.6931 0 20.4286V23.5714C0 25.3069 1.40741 26.7143 3.14286 26.7143H17.2857V40.8571C17.2857 42.5926 18.6931 44 20.4286 44H23.5714C25.3069 44 26.7143 42.5926 26.7143 40.8571V26.7143H40.8571C42.5926 26.7143 44 25.3069 44 23.5714V20.4286C44 18.6931 42.5926 17.2857 40.8571 17.2857Z"
                                  fill="#DADADA"
                                />
                              </svg>
                            </div>
                            <h5>อัปโหลดรูปภาพ</h5>
                          </div>
                          { 
                            imageErr &&
                            <div className="err-img">
                              <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                              <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                            </div>
                          }
                        </>
                      ) : (
                        <div>
                          <div className="input-upload active">
                            <div
                              className="icon-clear"
                              onClick={this.uploadClear}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.10178 5.99792L3.05089 8.04881L2.1601 7.15802L4.21099 5.10713L2.14629 3.04244L3.03708 2.15165L5.08797 4.20253L7.15267 2.13784L8.04345 3.02862L5.97876 5.09332L8.04345 7.15802L7.15267 8.04881L5.10178 5.99792Z"
                                  fill="#C4C4C4"
                                />
                              </svg>
                            </div>
                            <img src={fileUpload} alt="file-upload" />
                          </div>
                          { 
                            imageErr &&
                            <div className="err-img">
                              <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                              <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                            </div>
                          }
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <section className="footer-action">
              <BButton
                setStyle="outline block mini"
                onClick={() => this.props.navigate(`/collect-point`)}
              >
                ย้อนกลับ
              </BButton>
              <span style={{ width: "10px" }}></span>
              <BButton
                onClick={() => {
                  this.setState({ isSubmit: true }, () => {
                    this.onRenewSave();
                  });
                }}
                setStyle="mini"
              >
                ส่งข้อมูล
              </BButton>
            </section>
          </section>
        </div>
      </Layout>
    );
  }
}

function RenewMemberRoute(props) {
  let navigate = useNavigate();
  return <PointEvidence navigate={navigate} {...props} />;
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(RenewMemberRoute);
